import { render, staticRenderFns } from "./HornoComponent.vue?vue&type=template&id=22a57104&"
import script from "./HornoComponent.vue?vue&type=script&lang=js&"
export * from "./HornoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports